<template>
  <el-dropdown trigger="click" class='international' @command="handleSetLanguage">
    <div>
      <svg-icon class-name='international-icon' icon-class="language" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="lang in languages.available" :key="lang"
        :command="lang" :disabled="language===lang">{{lang}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    language () {
      return this.$store.getters.getLanguage
    },
    languages () {
      return this.$store.getters.getLanguages
    },
    translates () {
      return this.$store.getters.getTranslates
    }
  },
  methods: {
    handleSetLanguage (lang) {
      this.debug && console.log('handleSetLanguage: %o', lang)

      this.$store.dispatch('setLanguage', {lang})
      this.$i18n.locale = this.language

      let translates = this.translates
      let constantMessages = JSON.parse(localStorage.getItem('constantMessages')) || {}
      let localeMessage = Object.assign({}, constantMessages[lang], translates[lang])
      this.$i18n.setLocaleMessage(lang, localeMessage)

      // this.$message({
      //   message: 'switch language success',
      //   type: 'success'
      // })
    }
  }
}
</script>

<style scoped>
.international-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -5px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LangSelect/index.vue